import Vue from 'vue'
import VueLocalStorage from 'vue-ls'
Vue.use(VueLocalStorage)



// WEBPACK FOOTER //
// ./src/plugins/vue-local-storage.js